import { useQuery } from "react-query"
import { fetchIftaMiles } from "./api"

// eslint-disable-next-line import/prefer-default-export
export const useFetchIftaMiles = params => {
  return useQuery(["fetchIftaMiles", params], fetchIftaMiles)
}
